import React from 'react';

import { LoadingKinds } from '../../types';
import LoadingDots from './components/LoadingDots';
import LoadingPhaser from './components/LoadingPhaser';
import LoadingRadial from './components/LoadingRadial';
import { LoadingPlaceholderProps } from './type';

type PropTypes = {
  kind?: LoadingKinds;
} & LoadingPlaceholderProps;

const loadingKindToComponent: Record<LoadingKinds, React.FC<LoadingPlaceholderProps>> = {
  DOTS: LoadingDots,
  RADIAL: LoadingRadial,
  PHASER: LoadingPhaser,
};

const LoadingPlaceholder = ({ kind = LoadingKinds.DOTS, ...props }: PropTypes): JSX.Element | null => {
  const Component = loadingKindToComponent[kind];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
};

export default LoadingPlaceholder;
